<template>
    <div class="modal fade" id="rentalModal" tabindex="-1" aria-labelledby="rentalModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="rentalModalLabel">Reserveren</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-success" id="form-validation" role="alert" v-if="successMessage">{{ successMessage }}</div>
                    <div class="alert alert-danger" id="form-validation" role="alert" v-if="errorMessage" v-html="errorMessage"></div>
                    <form class="g-3 text-primary contact-form" id="form" @submit.prevent="submit" v-if="successMessage === null">
                        <div class="row">
                            <div v-for="(trailerType, i) in selected" class="mb-3">
                                <div class="d-flex align-items-center p-0 bg-grey rounded">
                                    <div class="col-xl-2 col-lg-3 col-md-4 mb-3 mb-md-0 ps-0">
                                        <img :src="trailerType.image" :alt="trailerType.title" class="img-fluid rounded me-3">
                                    </div>
                                    <div class="col-xl-10 col-lg-9 col-md-8 p-4 position-relative">
                                        <a href="#" @click.prevent="removeSelected(i)" class="bg-secondary badge rounded-pill position-absolute remove-btn" title="Selectie verwijderen"><i
                                            class="fas fa-times"></i></a>
                                        <h5 class="mb-4">{{ trailerType.title }}</h5>
                                        <DatePicker
                                            v-model="trailerType.range"
                                            is-range is-required is-dark
                                            @drag="dragValue = $event"
                                            :select-attribute="selectDragAttribute"
                                            :drag-attribute="selectDragAttribute"
                                            :min-date="new Date()"
                                            :columns="$screens({ default: 1, lg: 2 })"
                                            :rows="$screens({ default: 1, lg: 2 })"
                                            :is-expanded="$screens({ default: true, lg: false })">
                                            <template v-slot="{ inputValue, inputEvents }">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <input
                                                        :value="inputValue.start"
                                                        v-on="inputEvents.start"
                                                        :class="'form-control' + (hasError('selectedTrailerTypes.' + i + '.range.start') ? ' is-invalid' : '')"
                                                        placeholder="Begindatum"
                                                    />
                                                    <i class="fad mx-3 fa-calendar-check calendar-icon"></i>
                                                    <input
                                                        :value="inputValue.end"
                                                        v-on="inputEvents.end"
                                                        :class="'form-control' + (hasError('selectedTrailerTypes.' + i + '.range.start') ? ' is-invalid' : '')"
                                                        placeholder="Einddatum"
                                                    />
                                                </div>
                                            </template>
                                            <template v-slot:day-popover="{ format }">
                                                <div>
                                                    {{ format(dragValue ? dragValue.start : range.start, 'D MMM') }}
                                                    -
                                                    {{ format(dragValue ? dragValue.end : range.end, 'D MMM') }}
                                                </div>
                                            </template>
                                        </DatePicker>
                                        <div class="invalid-feedback d-block" v-if="hasError('selectedTrailerTypes.' + i + '.range.start')">
                                            Selecteer een begin- en einddatum
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <label for="inputCompany" class="form-label fw-bold">Bedrijfsnaam</label>
                                <input type="text" class="form-control" id="inputCompany" name="company" v-model="company">
                                <div class="invalid-feedback d-block" v-if="hasError('company')">
                                    Dit veld is verplicht.
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="inputName" class="form-label fw-bold">Naam</label>
                                <input type="text" :class="'form-control' + (hasError('name') ? ' is-invalid' : '')" id="inputName" name="name" v-model="name">
                                <div class="invalid-feedback d-block" v-if="hasError('name')">
                                    Dit veld is verplicht.
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="inputEmail" class="form-label fw-bold">E-mailadres</label>
                                <input type="email" :class="'form-control' + (hasError('email') ? ' is-invalid' : '')" id="inputEmail" name="email" v-model="email">
                                <div class="invalid-feedback d-block" v-if="hasError('email')">
                                    Vul een geldig e-mail adres in.
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="inputPhone" class="form-label fw-bold">Telefoonnummer</label>
                                <input type="text" :class="'form-control' + (hasError('phone') ? ' is-invalid' : '')" id="inputPhone" name="phone" v-model="phone">
                                <div class="invalid-feedback d-block" v-if="hasError('phone')">
                                    Dit veld is verplicht.
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="exampleFormControlTextarea1" class="form-label fw-bold">Opmerkingen</label>
                                <textarea :class="'form-control' + (hasError('comments') ? ' is-invalid' : '')" id="exampleFormControlTextarea1" rows="3" name="comments" v-model="comments"></textarea>
                                <div class="invalid-feedback d-block" v-if="hasError('comments')">
                                    Dit veld is verplicht.
                                </div>
                            </div>
                            <div class="Btn d-flex justify-content-end">
                                <button type="submit"
                                        class="btn btn-secondary rounded" @clicks.prevent="submit">
                                <span v-if="this.loading === false">
                                    Verstuur reserveringsaanvraag
                                </span>
                                    <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <button type="button" class="btn btn-primary btn-reserve" data-bs-toggle="modal" data-bs-target="#rentalModal"><span class="count">{{ counter }}</span> Reserveringsaanvraag</button>
</template>

<style scoped>
.calendar-icon {
    font-size: 1.5em;
}

.remove-btn {
    top: -10px;
    right: -10px;
    border: 3px solid white;
}
</style>

<script>
import {DatePicker} from 'v-calendar';
import axios from 'axios';
import {Modal} from 'bootstrap';

export default {
    components: {
        DatePicker
    },
    data() {
        return {
            counter:             0,
            selected:            [],
            selectDragAttribute: {
                backgroundColor: 'red'
            },
            dateValue:           null,
            company:             null,
            name:                null,
            email:               null,
            phone:               null,
            comments:            null,
            successMessage:      null,
            errorMessage:        null,
            errors:              [],
            loading:             false
        }
    },
    computed: {
        selectDragAttribute() {
            return {
                popover: {
                    visibility:    'hover',
                    isInteractive: false, // Defaults to true when using slot
                },
            };
        },
        layout() {
            return this.$screens(
                {
                    // Default layout for mobile
                    default: {
                        columns:    1,
                        rows:       1,
                        isExpanded: true,
                    },
                    // Override for large screens
                    lg: {
                        columns:    2,
                        rows:       2,
                        isExpanded: false,
                    },
                },
            );
        }
    },
    methods:  {
        checkCheckboxes() {
            const checkedElements = document.querySelectorAll('.filter-item input[type="checkbox"]:checked');
            this.selected         = [];

            checkedElements.forEach((el) => {
                if(el.checked) {
                    this.selected.push({
                        id:    el.parentNode.parentNode.parentNode.parentNode.dataset.trailertypeId,
                        title: el.parentNode.parentNode.parentNode.parentNode.dataset.trailertypeTitle,
                        image: el.parentNode.parentNode.parentNode.parentNode.dataset.trailertypeImage,
                        range: {
                            start: null,
                            end:   null
                        },
                    });
                }
            })

            this.counter = checkedElements.length;
        },
        removeSelected(index) {
            if(this.selected[index]) {
                this.selected.splice(index, 1);
                this.counter--;
            }

            if(document.querySelectorAll('.filter-item input[type="checkbox"]:checked')[index]) {
                document.querySelectorAll('.filter-item input[type="checkbox"]:checked')[index].checked = false;
            }

            if(this.counter === 0) {
                this.closeModal();
            }
        },
        submit() {
            this.errorMessage = null;

            if(this.selected.length === 0) {
                this.errorMessage = 'Selecteer minimaal 1 optie.<br> <a class="btn btn-secondary rounded mt-4" href="#" data-bs-dismiss="modal">Sluiten</a>';
                return;
            }

            const formData = {
                company:              this.company,
                name:                 this.name,
                email:                this.email,
                phone:                this.phone,
                comments:             this.comments,
                selectedTrailerTypes: this.selected
            }

            this.loading = true;
            axios.post('/api/create-rental-reservation', formData).then((response) => {
                this.successMessage = response.data.message;
                this.dateValue      = null;
                this.company        = null;
                this.name           = null;
                this.email          = null;
                this.phone          = null;
                this.comments       = null;
                this.selected       = [];
                this.counter        = 0;

                document.querySelectorAll('.filter-item input[type="checkbox"]').forEach((el) => {
                    el.checked = false;
                });
            }).catch((exception) => {
                this.errors = exception.response.data.errors;
            }).finally(() => {
                this.loading = false;
            });
        },
        openModal() {
            const modal = Modal.getOrCreateInstance(document.getElementById('rentalModal'));
            modal.show();
        },
        closeModal() {
            const modal = Modal.getOrCreateInstance(document.getElementById('rentalModal'));
            modal.hide();
        },
        hasError(field) {
            return this.errors.hasOwnProperty(field);
        }
    },
    created() {
        this.checkCheckboxes();

        document.querySelectorAll('.filter-item input[type="checkbox"]').forEach((element) => {
            element.addEventListener('change', (e) => {
                this.checkCheckboxes();
            });
        });
    },
    mounted() {
        let select = location.search.replace(/^\?select=/, '');
        if(select && document.querySelector('[data-trailertype-id="' + select + '"]')) {
            document.querySelector('[data-trailertype-id="' + select + '"] input[type="checkbox"]').checked = true;
            this.checkCheckboxes();
            this.openModal();
        }
    }
}
</script>
